<template>
	<div id="loyout" class="screen-wrapper">
		<div class="screen" id="screen">
			<div class="computility">
				<el-carousel
					class="el-carousel"
					indicator-position="none"
					arrow="never"
					:autoplay="false"
					ref="myCarousel">
					<!-- 算力调度 -->
					<el-carousel-item name="0">
						<HashPower type="1" />
					</el-carousel-item>
				</el-carousel>

				<!-- <MyFooter @carouselAt="carouselAt" ref="MyFooter"/> -->

				<!-- <div class="fullScreen flex">
					<img v-show ="showFullScreen" src="@/assets/images/index/fullscreen.png" @click="clickFullScreen">
					<img  v-show ="!showFullScreen" src="@/assets/images/index/fullscreen-exit.png" @click="clickExit">
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
import Dispatch from './carouselItem/dispatch'
import Overview from './carouselItem/overview'
// import Monitor from './carouselItem/monitor'
import MyFooter from './components/myFooter.vue'
import HashPower from './carouselItem/HashPower'
export default {
	components: {
		Dispatch,
		Overview,
		// Monitor,
		MyFooter,
        HashPower
	},
    data() {
        return {
			showFullScreen: true,
			timer: null,
			index: 0,
			intervalNum: 100,
			pageInterval:null
		}
    },
	mounted() {
		let that = this
		//初始化自适应  ----在刚显示的时候就开始适配一次
		that.handleScreenAuto();
		//绑定自适应函数   ---防止浏览器栏变化后不再适配
		window.onresize = (function(){
			that.handleScreenAuto()
		})
		// this.timer = setInterval(()=>{
		// 	if(this.index == 0){
		// 		this.index++
		// 		this.$refs.MyFooter.goCarouselItem('',1)
		// 		this.carouselAt(1)
		// 	}else{
		// 		this.index = 0
		// 		this.$refs.MyFooter.goCarouselItem('',0)
		// 		this.carouselAt(0)
		// 	}	
		// },30000)

        if(this.pageInterval) {
			clearInterval(this.pageInterval)
			this.pageInterval = null
		}
		// if(sessionStorage.getItem('fromUser') != 'guizhou' && sessionStorage.getItem('fromUser') != 'suzhou') {
		// this.pageInterval = setInterval(() => {
		// 	this.intervalNum--
		// 	console.log(this.intervalNum, 'fromUser')
		// 	if(this.intervalNum < 0 ) {
		// 		this.$router.replace({
		// 			path: 'monitor2th2',
		// 		})
		// 	}
		// }, 1000)

		// document.onmousemove = (() => {
		// 	this.intervalNum = this.intervalNumSet
		// })
	},
	destroyed () {
        console.log('destroyed')
        clearInterval( this.timer )
		clearInterval(this.pageInterval)
    },
	methods: {
		//数据大屏自适应函数
		handleScreenAuto(){
			// 3840 × 2160 
			const designDraftWidth = 5120;//设计稿的宽度
			const designDraftHeight = 2184;//设计稿的高度
			//根据屏幕的变化适配的比例
			const scale = (document.documentElement.clientWidth / document.documentElement.clientHeight) < (designDraftWidth / designDraftHeight) ?
				(document.documentElement.clientWidth / designDraftWidth) :
				(document.documentElement.clientHeight / designDraftHeight);
			//缩放比例
			console.log('===document.documentElement.clientWidth===', document.documentElement.clientHeight / designDraftHeight)
			console.log('===========scale==========', scale)
			document.querySelector('#screen').style.transform = `scale(${scale}) translate(-50%)`;
			// document.querySelector('#screen').style.transform = `scale(${scale}, ${scale * 0.99}) translate(-50%)`;
		},

		//全屏
		clickFullScreen(){
			const docElm = document.documentElement
			if (docElm.requestFullscreen) {
				docElm.requestFullscreen()
			} else if (docElm.msRequestFullscreen) {
				docElm.msRequestFullscreen()
			} else if (docElm.mozRequestFullScreen) {
				docElm.mozRequestFullScreen()
			} else if (docElm.webkitRequestFullScreen) {
				docElm.webkitRequestFullScreen()
			}
			this.showFullScreen = !this.showFullScreen;
		},

		//点击退出全屏
		clickExit(){
			if (document.exitFullscreen) {
				document.exitFullscreen()
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen()
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen()
			} else if (document.webkitCancelFullScreen) {
				document.webkitCancelFullScreen()
			}
			this.showFullScreen = !this.showFullScreen;
		},

		// carouselAt
		carouselAt(index) {
			console.log('setActiveItem', index)
			this.$refs.myCarousel.setActiveItem(index)
		}
	}
}
</script>

<style lang="scss" scoped>
.screen-wrapper {
	height: 100%;
	width: 100%;
	background: #000;
	.screen {
		overflow: hidden;
		display: inline-block;
		width: 5120px;
		height: 2184px;
		// width: 2790px;
		// height: 1880px;
		transform-origin: 0 0;
		position: absolute;
		left: 50%;
	}
}

.computility {
	width: 100%;
	height: 100%;
	background: #000;
	position: relative;
	.el-carousel {
		height: 100%;
		::v-deep .el-carousel__container {
			height: 100%;
		}
	}
	.fullScreen {
		position: fixed;
        width: 30px;
        height: 30px;
        top: 60px;
        right: 20px;
		z-index: 10;
	}
}
</style>